import { RootState } from '@/store/main';

export const selectCookieBanner = (state: RootState) =>
  state.project.workingProject?.settings.gdpr?.enable_cookie_banner || false;
export const selectMarketingEmailOptions = (state: RootState) =>
  state.project.workingProject?.registration_settings?.marketing_email_options;
export const selectIsPublishLocked = (state: RootState) => state.project.workingProject?.is_publish_locked || false;
export const selectDmaId = (state: RootState) => state.project.workingProject?.dma_id;
export const selectFavicon = (state: RootState) => state.project.workingProject?.favicon;
export const selectSocialSharingSettings = (state: RootState) => state.project.workingProject?.social_sharing || null;
export const selectShowCalendar = (state: RootState) =>
  state.project.workingProject?.settings.show_add_to_cal_btn || false;

export const selectSessionFooter = (state: RootState) =>
  state.project.workingProject?.settings.display_session_footer || false;
export const selectDisplaySessions = (state: RootState) =>
  state.project.workingProject?.settings.display_sessions || false;
export const selectWatchlist = (state: RootState) =>
  state.project.workingProject?.settings.personalizedAttendeeList || false;
